<form *ngIf="form" [formGroup]="form">
  <div class="row">
    <!-- Main -->
    <div class="col-4" *ngIf="dataEntity && !reloadingForms">
      <div class="form-group" [class.has-error]="label.touched && !label.valid">
        <label class="bmd-label-floating" for="label">
          Label
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="label"
          name="label"
          [attr.maxlength]="isStaffJanus ? 25 : null"
          (blur)="sanitize()"
          [(ngModel)]="dataEntity.label"
        />
        <small *ngIf="isStaffJanus" class="text-muted">
          {{ form.controls['label']?.value?.length || 0 }}/25 characters
        </small>
        <wm-control-message
          [control]="form.controls['label']"
        ></wm-control-message>
      </div>

      <div class="form-group" *ngIf="dataEntity.isHelpText">
        <label class="bmd-label-floating" for="instructions">
          Help Text
        </label>
        <textarea
          class="form-control"
          rows="3"
          formControlName="instructions"
          name="instructions"
          [(ngModel)]="dataEntity.instructions"
        ></textarea>
      </div>

      <div class="form-group">
        <label class="bmd-label-floating" for="dataEntityType">
          Data Entity Type
        </label>
        <select
          class="form-control"
          (change)="changeType()"
          formControlName="dataEntityType"
          name="dataEntityType"
          [(ngModel)]="selectedTypeCode"
        >
          <option *ngFor="let de of dataEntityTypes" [value]="de.code">
            {{ de.name }}
          </option>
        </select>
      </div>
      <div
        class="form-group"
        [class.has-error]="templateCode.touched && !templateCode.valid"
      >
        <label class="bmd-label-floating" for="templateCode">
          Template Code
        </label>
        <input
          type="text"
          class="form-control required"
          formControlName="templateCode"
          name="templateCode"
          [(ngModel)]="dataEntity.templateCode"
        />
        <div *ngIf="changingCustomFieldTemplateCode" class="text-warning">
          Note: All Custom Fields associated with this Data Entity will be
          updated with the new Template Code once the change is published.
        </div>
        <wm-control-message
          [control]="form.controls['templateCode']"
        ></wm-control-message>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="switch">
            <label>
              <input
                type="checkbox"
                formControlName="isRequired"
                [(ngModel)]="dataEntity.isRequired"
              />
              Required
            </label>
          </div>
        </div>
        <div class="col-8" *ngIf="canConditionallyRequire">
          <div class="switch">
            <label>
              <input
                type="checkbox"
                formControlName="showRequiredConditional"
                [(ngModel)]="showConditionalRequired"
                (ngModelChange)="requireConditionalChanged($event)"
              />
              Conditionally Required
            </label>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="canConditionallyRequire">
        <div class="col">
          <ng-container *ngIf="showConditionalRequired">
            <div class="row mt-4">
              <div class="col-11">
                <h6>Required if criteria is true</h6>
              </div>
            </div>
            <wm-condition-group
              [conditionSources]="conditionSources"
              [group]="dataEntity.requiredCriteria.group"
              (conditionChanges)="
                requiredCriteriaChanged(dataEntity.requiredCriteria.group)
              "
              *ngIf="conditionSources && dataEntity.requiredCriteria"
            >
            </wm-condition-group>

            <wm-control-message
              [control]="form.controls['requiredCriteria']"
            ></wm-control-message>
          </ng-container>
        </div>
      </div>

      <div class="row mt-3" *ngIf="canConditionallyShow">
        <div class="col">
          <div class="switch">
            <label>
              <input
                type="checkbox"
                formControlName="showVisibleConditional"
                [(ngModel)]="showConditionalVisible"
                (ngModelChange)="visibleConditionChanged($event)"
              />
              Conditionally Visible
            </label>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="showConditionalVisible">
        <div class="col">
          <div class="row mt-4">
            <div class="col-11">
              <h6>Visible if criteria is true</h6>
            </div>
          </div>
          <wm-condition-group
            [conditionSources]="conditionSources"
            [group]="dataEntity.visibleCriteria.group"
            (conditionChanges)="
              visibleCriteriaChanged(dataEntity.visibleCriteria.group)
            "
            *ngIf="conditionSources && dataEntity.visibleCriteria"
          >
          </wm-condition-group>
          <wm-control-message
            [control]="form.controls['visibleCriteria']"
          ></wm-control-message>
        </div>
      </div>
      <div class="switch" *ngIf="!_context.client">
        <label>
          <input
            type="checkbox"
            formControlName="isSystemEntity"
            [(ngModel)]="dataEntity.isSystemEntity"
          />
          System Entity
        </label>
      </div>
    </div>
    <!-- Entity specific-->
    <div
      [ngStyle]="{
        display: dataEntity && dataEntity.hasEditor ? 'block' : 'none'
      }"
      [ngClass]="widthClass(dataEntity && dataEntity.hasPreview)"
    >
      <template #dataEntityEditor></template>
    </div>

    <div
      *ngIf="dataEntity && dataEntity.hasPreview"
      [ngClass]="widthClass(dataEntity.hasEditor)"
    >
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">
            Preview
          </h5>

          <app-loader *ngIf="!isPreviewReady"></app-loader>

          <div *ngIf="isPreviewReady">
            <wm-data-entity-input
              *ngIf="previewDE.templateCode"
              [entity]="previewDE"
              [form]="previewForm"
              [isPreview]="true"
              [activity]="activity"
            ></wm-data-entity-input>
          </div>
        </div>
      </div>
    </div>
  </div>

  <wm-workflow-validation-item
    *ngIf="dataEntity"
    [workflowId]="workflow.id"
    [activityId]="dataEntity.parent.id"
    [itemId]="dataEntity.templateCode"
  ></wm-workflow-validation-item>
</form>
